import { render, staticRenderFns } from "./surface_post_author.vue?vue&type=template&id=7670c354&scoped=true&"
import script from "./surface_post_author.vue?vue&type=script&lang=js&"
export * from "./surface_post_author.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_author.vue?vue&type=style&index=0&id=7670c354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670c354",
  null
  
)

export default component.exports